import { TokenInterface } from 'app/core/authentication/models/token.model';
import { Error } from 'app/core/error-handler/models';
import { UserInterface } from 'app/core/user/models';

export interface AuthStateInterface {
  isLicensed?: boolean;
  resetTokenValidated?: boolean;
  jwt?: string;
  token?: TokenInterface;
  error?: Error;
  authenticatedUser?: UserInterface;
}

export class AuthState implements AuthStateInterface {
  public isLicensed?: boolean;
  public resetTokenValidated?: boolean;
  public jwt?: string;
  public token?: TokenInterface;
  public error?: Error;
  public authenticatedUser?: UserInterface;

  constructor({
      isLicensed = undefined,
      resetTokenValidated = undefined,
      jwt = undefined,
      token = undefined,
      error = undefined,
      authenticatedUser = undefined,
    }: AuthStateInterface) {
    this.isLicensed = isLicensed;
    this.resetTokenValidated = resetTokenValidated;
    this.jwt = jwt;
    this.token = token;
    this.error = error;
    this.authenticatedUser = authenticatedUser;
  }
}
